import { Box, Card, Grid, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { apiput, apiget } from '../../service/api';
import { SectionCard, SectionHeader, FieldRow } from './LeadViewStyles';

const LeadInformation = ({ data, setUserAction }) => {
  const [formData, setFormData] = useState({ ...data });
  const [isEdited, setIsEdited] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    setFormData({
      ...data,
      assigned_agent: data.assigned_agent?._id || '',
    });
  }, [data]);


  useEffect(() => {
    // Fetch the list of users
    const fetchUserData = async () => {
      const result = await apiget('user/list');
      if (result && result.status === 200) {
        setUsers(result.data.result);
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setIsEdited(true);
  };

  const handleSave = async () => {
    const result = await apiput(`lead/edit/${data._id}`, formData);
    setUserAction(result);
    if (result.status === 200) {
      toast.success('Lead information updated successfully!');
      setIsEdited(false);
    } else {
      toast.error('Failed to update lead information.');
    }
  };

  return (
    <div>
      <Card style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px' }}>
        <Box p={3}>
          {/* Lead Details */}
          <SectionCard>
            <SectionHeader>Lead Details</SectionHeader>
            <FieldRow>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Date Received"
                  name="dateReceived"
                  value={formData.dateReceived || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth margin="dense">
                  <InputLabel id="loan-officer-label">Loan Officer Assigned</InputLabel>
                  <Select
                    labelId="loan-officer-label"
                    label="Loan Officer Assigned"
                    name="assigned_agent"
                    value={formData.assigned_agent || ''}
                    onChange={handleChange}
                  >
                    {users.map((user) => (
                      <MenuItem key={user._id} value={user._id}>
                        {`${user.firstName} ${user.lastName}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Date LO Assigned"
                  name="dateLOAssigned"
                  value={formData.dateLOAssigned || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Loan Purpose"
                  name="loanPurpose"
                  value={formData.loanPurpose || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Sales Price"
                  name="salesPrice"
                  value={formData.salesPrice || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Lead Source"
                  name="leadSource"
                  value={formData.leadSource || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Loan Amount"
                  name="loanAmount"
                  value={formData.loanAmount || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Estimated Value"
                  name="estimatedValue"
                  value={formData.estimatedValue || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Lead Source Company"
                  name="leadSourceCompany"
                  value={formData.leadSourceCompany || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="House Account?"
                  name="houseAccount"
                  value={formData.houseAccount || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Agent Contact Info - side by side */}
          <FieldRow>
            <Grid item xs={12} sm={6}>
              <SectionCard sx={{ mb: 0, height: '100%' }}>
                <SectionHeader>Listing Agent Contact</SectionHeader>
                <TextField
                  label="Listing Agent Name"
                  name="listingAgentName"
                  value={formData.listingAgentName || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Listing Agent Company"
                  name="listingAgentCompany"
                  value={formData.listingAgentCompany || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Listing Agent Phone"
                  name="listingAgentPhone"
                  value={formData.listingAgentPhone || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Listing Agent Email"
                  name="listingAgentEmail"
                  value={formData.listingAgentEmail || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </SectionCard>
            </Grid>
            <Grid item xs={12} sm={6}>
              <SectionCard sx={{ mb: 0, height: '100%' }}>
                <SectionHeader>Buyer Agent Contact</SectionHeader>
                <TextField
                  label="Buyer Agent Name"
                  name="buyerAgentName"
                  value={formData.buyerAgentName || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Buyer Agent Company"
                  name="buyerAgentCompany"
                  value={formData.buyerAgentCompany || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Buyer Agent Phone"
                  name="buyerAgentPhone"
                  value={formData.buyerAgentPhone || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
                <TextField
                  label="Buyer Agent Email"
                  name="buyerAgentEmail"
                  value={formData.buyerAgentEmail || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </SectionCard>
            </Grid>
          </FieldRow>

          {/* Save Button */}
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={!isEdited}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Card>
    </div>
  );
};

export default LeadInformation;
